/*
 * @Author: cn1994
 * @Date: 2023-12-25 13:40:56
 * @LastEditors: cn1994
 * @LastEditTime: 2025-04-15 16:07:32
 * @Description: file content
 */
const routes = [
  // 课程管理
  {
    path: "/courses",
    name: "courses",
    meta: {
      title: '课程管理',
      hasBack: false,
      volcengine: true,
    },
    component: () => import("../pages/educational/courses.vue"),
  },
  // 创建课程
  {
    path: "/courses/created",
    name: "courses/created",
    meta: {
      title: '创建课程',
      hasBack: true
    },
    component: () => import("../pages/educational/courses/created.vue")
  },
  // 课程管理
  {
    path: "/coursesV2",
    name: "coursesV2",
    meta: {
      title: '课程管理',
      hasBack: false,
      volcengine: true,
    },
    component: () => import("../pages/newPeriodCard/courses/courses.vue"),
  },
  // 创建课程
  {
    path: "/coursesV2/created",
    name: "coursesV2/created",
    meta: {
      title: '创建课程',
      hasBack: true
    },
    component: () => import("../pages/newPeriodCard/courses/created.vue")
  },
  //课表管理
  {
    path: "/scheduleManagement",
    name: 'scheduleManagement',
    meta: {
      title: '课表管理',
      hasBack: false,
      volcengine: true,
    },
    component: () => import("../pages/classSchedule/ClassSchedule.vue")
  },
  {
    path: "/rollCallRecord",
    name: 'rollCallRecord',
    meta: {
      title: '点名记录',
      hasBack: false,
      volcengine: true,
    },
    component: () => import("../pages/rollCallRecord/index.vue")
  },
  //培训项目
  {
    path: "/trainItems",
    name: 'trainItems',
    meta: {
      title: '培训项目',
      hasBack: false
    },
    component: () => import("../pages/educational/trainItems")
  },
  {
    path: "/trainItems/create",
    name: 'trainItems/create',
    meta: {
      title: '创建项目',
      hasBack: false
    },
    component: () => import("../pages/educational/trainItems/create")
  },
  {
    path: "/trainItems/detail",
    name: 'trainItems/detail',
    meta: {
      title: '培训详情',
      hasBack: false
    },
    component: () => import("../pages/educational/trainItems/detail")
  }
];

export default routes;
